<template>
  <div :class="is_premium?'pta-documents-premium':'pta-documents'" v-if="is_loaded">
    <h1>Documents</h1>
    <div class="pta-content-center">
      <h2>Upload your marketing materials</h2>
      <ul class="pta-uploads">
        <li>
          <h3>Fact Sheet</h3>
          <a :href="'/fs2/'+user_id_cur+'/pdf'" class="pta-ai-link">AI Generator</a>
          <file-upload-input v-if="is_premium" :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="1"></file-upload-input>
        </li>
        <li><h3>Presentation</h3>
          <a :href="'/ps2/'+user_id_cur+'/pdf'" class="pta-ai-link">AI Generator</a>
          <file-upload-input v-if="is_premium" :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="2"></file-upload-input>
        </li>
        <li><h3>Team Bios</h3>
          <a :href="'/bios2/'+user_id_cur+'/pdf'" class="pta-ai-link">AI Generator</a>
          <file-upload-input v-if="is_premium" :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="3"></file-upload-input>
        </li>
        <li><h3>Case Studies</h3>
          <file-upload-input v-if="is_premium" :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="4"></file-upload-input>
        </li>
        <li><h3>FAQ/DDQ</h3>
          <file-upload-input v-if="is_premium" :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="5"></file-upload-input>
        </li>
        <li><h3>Track Record</h3>
          <file-upload-input v-if="is_premium" :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="6"></file-upload-input>
        </li>
        <li><h3>Financial Model</h3>
          <file-upload-input v-if="is_premium" :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="7"></file-upload-input>
        </li>
        <li><h3>Key Terms</h3>
          <file-upload-input v-if="is_premium" :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="8"></file-upload-input>
        </li>
        <li><h3>Market Reports</h3>
          <file-upload-input v-if="is_premium" :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="9"></file-upload-input>
        </li>
        <li><h3>Any other marketing materials</h3>
          <file-upload-input v-if="is_premium" :button-text="'Choose file to upload'" :token="upload_token" module="documents" :clear-file="clear_message_attachment" :module-id="10"></file-upload-input>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {v4 as uuidv4} from "uuid";
import fileUploadInput from '../../components/file-upload-input'

export default {
  components: {fileUploadInput},
  mounted(){
    this.user_id_cur = helper.getAuthUser('id');
    this.getQuestionnaire();
  },
  methods: {
    getQuestionnaire(){
      axios.get('/api/user/profile/questionnaire')
          .then(response => response.data)
          .then(response => {
            this.is_premium     = response.user.profile.is_premium;
            this.is_premium     = true;
            if(response.user.profile.is_confirmed==1){
              this.is_confirmed   = true;
            }else{
              this.is_confirmed   = false;
            }
            this.upload_token = response.user.profile.upload_token;
            this.is_loaded = true;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
  },
  data() {
    return {
      user_id_cur : 0,
      is_premium: true,
      is_confirmed: false,
      is_loaded: false,
      clear_message_attachment: false,
      upload_token: ''
    }
  },
  computed: {
  },
  filters: {
  },
}
</script>
<style>
  .pta-ai-link{
    position:absolute;
    right:20px;
    top:20px;
    background:transparent url(/images/icon_ai.svg) no-repeat left center;
    background-size:auto 100%;
    padding-left:30px;
    display:block;
    font-weight:500;
    font-size:14px;
    color:#34a7c2;
  }
  .pta-uploads li{
    position: relative;
  }
</style>